// extracted by mini-css-extract-plugin
module.exports = {"container":"TranslationView_container__M0fhJ","wrapper":"TranslationView_wrapper__C8vfW"};